<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat >
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">NMI Rebate Rates</v-toolbar-title>
    <v-spacer/>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>

  <v-data-table
    disable-pagination
    hide-default-footer
    :height="520"
    fixed-header
    :headers="headers"
    :items="confirmedNMIRebates ? allNMIRebates : allNMIRebates.filter(a => a.CheckerID === 0)"
    :search="search"
    sort-by="MakeDate"
    sort-desc
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top >

        <!-- rejection dialog  -->
          <v-dialog persistent v-model="rejectionDialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
              </v-card-title>

              <v-card-text>
                <v-select
                  filled dense
                  v-model="RejectionStatus"
                  :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="RejectionReasonDescription"
                  item-value="RejectionReasonID"
                  label="Rejection Reasons"
                ></v-select>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <div class="text-right mb-4">
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="RejectionStatus = 0; rejectionDialog = false">cancel</v-btn>
                  <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus()">ok</v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>


<!-- the delete dialog  -->
          <v-dialog persistent v-model="deleteDialog" max-width="350px">
            <v-card>
              <v-card-title>
                <span class="subtitle-1 grey--text text-center ma-4 mx-7">Are you sure you want to DELETE  the selected item?</span>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <div class="text-right mb-4">
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteDialog = false">no</v-btn>
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteItem()">yes</v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>


      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="create">
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Create New NMI Rebate Rate</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-row class="ml-1 mr-1">
        <v-col>
          <v-text-field
            dense filled
            color="#2A353D"
            v-model="rebate.PurchaseRate"
            label="Purchase Rate"
            type="number" required
            :rules="TextFieldRules"
          ></v-text-field>
          <v-text-field
            dense filled
            color="#2A353D"
            v-model="rebate.PurchaseTaxRate"
            label="Purchase TaxRate"
            type="number" required
            :rules="TextFieldRules"
          ></v-text-field>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="rebate.EffectiveDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="rebate.EffectiveDate"
                label="Effective Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                :rules="TextFieldRules"
                dense filled color="#2A353D"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker color="#2A353D" v-model="rebate.EffectiveDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
              <v-btn outlined small color="#2A353D" @click="$refs.menu.save(rebate.EffectiveDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="rebate.SaleRate"
            label="Sale Rate"
            type="number" required
            :rules="TextFieldRules"
          ></v-text-field>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="rebate.SaleTaxRate"
            label="Sale TaxRate"
            type="number" required
            :rules="TextFieldRules"
          ></v-text-field>
          <v-select
            filled dense
            v-model="rebate.TransactionChargeID"
            :items="allTransactionCharges.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            item-text="TransactionCharge"
            item-value="TransactionChargeID"
            label="Charge"
            :rules="TextFieldRules"
          ></v-select>
          <div class="text-right mt-7">
            <v-btn class="white--text mr-3" small color="#2A353D" @click="closeCreate()">close</v-btn>
            <v-btn class="white--text mr-3" small color="#2A353D" :disabled="!valid" @click="createNew()">submit</v-btn>          
          </div>   
        </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>

      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="edit" >
        <v-toolbar dense flat color="#DBEFFA">
          <v-spacer/>
          <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentRebate.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
          <span v-if="currentRebate.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentRebate.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
          <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentRebate.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
       </v-toolbar>
        <v-row class="ml-1 mr-1">
        <v-col>
          <v-text-field
            dense filled
            color="#2A353D"
            v-model="currentRebate.PurchaseRate"
            label="Purchase Rate"
            type="number" required
            :rules="TextFieldRules"
          ></v-text-field>
          <v-text-field
            dense filled
            color="#2A353D"
            v-model="currentRebate.PurchaseTaxRate"
            label="Purchase TaxRate"
            type="number" required
            :rules="TextFieldRules"
          ></v-text-field>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="currentRebate.EffectiveDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="currentRebate.EffectiveDate"
                label="Effective Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                :rules="TextFieldRules"
                dense filled color="#2A353D"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker color="#2A353D" v-model="currentRebate.EffectiveDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
              <v-btn outlined small color="#2A353D" @click="$refs.menu.save(currentRebate.EffectiveDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="currentRebate.SaleRate"
            label="Sale Rate"
            type="number" required
            :rules="TextFieldRules"
          ></v-text-field>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="currentRebate.SaleTaxRate"
            label="Sale TaxRate"
            type="number" required
            :rules="TextFieldRules"
          ></v-text-field>
          <v-select
            filled dense
            v-model="currentRebate.TransactionChargeID"
            :items="allTransactionCharges.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            item-text="TransactionCharge"
            item-value="TransactionChargeID"
            label="Charge"
            :rules="TextFieldRules"
          ></v-select>
          <div class="text-right mt-7">
            <v-btn class="white--text mr-3" small color="#2A353D" @click="view=false;closeEdit()">close</v-btn>
            <v-btn class="white--text mr-3" v-if="!view" small color="#2A353D" @click="update()">save</v-btn>          
          </div>
        </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>
      <v-container row>

        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-if="showCreateBtn == true" v-show="confirmedNMIRebates" @click="showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-if="confirmedNMIRebates" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "xls"
                name    = "NMIRebateRates.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "csv"
                name    = "NMIRebateRates.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" v-if="confirmedNMIRebates" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <v-btn v-if="!confirmedNMIRebates" @click="confirmedNMIRebates = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>
    </template>


  <template v-slot:item.status="{ item }">
      <v-chip outlined small color="error" v-if="item.RejectionID !== 0">rejected</v-chip>
      <v-chip outlined small color="warning" v-if="item.CheckerID == 0">pending</v-chip>
      <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0">confirmed</v-chip>
    </template>


    <template v-slot:item.actions="{ item }">
      <v-tooltip v-if="!confirmedNMIRebates && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="setActiveRebate(item, index); updateStatus()"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>confirm</span>
      </v-tooltip>
      <v-tooltip v-if="!confirmedNMIRebates && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="reject(); setActiveRebate(item, index)"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>reject</span>
      </v-tooltip>
      <v-btn
        v-show="confirmedNMIRebates"
        small outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
       @click="setActiveRebate(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>edit</span>
      </v-btn>
          <!-- The view button  -->
       <v-btn
        small outlined
        :disabled="edit"
        @click="view = true; setActiveRebate(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>view</span>
      </v-btn>

      <!-- the delete icon  -->
       <v-icon
            :disabled="item.MakerID == currentUser.SecurityUserID && item.CheckerID == 0 ? false : true"
            color="#2A353D" @click="setActiveRebate(item, index); deleteDialog = true"
          >
          mdi-trash-can-outline
          </v-icon>
    </template>

    <template v-slot:item.TransactionChargeID="{ item }">
      {{ allTransactionCharges.filter(a => a.TransactionChargeID == item.TransactionChargeID).map(a => a.TransactionCharge)[0] }}
    </template>

    <template v-slot:item.EffectiveDate="{ item }">
      {{ item.EffectiveDate | moment("DD MMMM YYYY") }}
    </template>

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {

  data () {
    return {
      confirmedNMIRebates: true,
      edit: false,
      create:false,
      permitted: null,
      permitted_dialog: true,
      // the initialisation of the view variable 
      view: false,
      deleteDialog:false,
      rejectionDialog: false,
      RejectionStatus: 0,
      message: '',
      search: '',
      valid: true,
      menu: false,
      content: '',
      currentRebate: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        {
          text: 'Charge',
          align: 'start',
          sortable: true,
          value: 'TransactionChargeID'
        },
        { text: 'Effective Date', value: 'EffectiveDate', sortable: false },
        { text: 'Purchase Rate', value: 'PurchaseRate', sortable: false },
        { text: 'Sale Rate', value: 'SaleRate', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },

      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      rebate: {},
      submitted: false,
    }
  },

  computed: {
    ...mapGetters([
      "allNMIRebates",
      "allCountries",
      "allCities",
      "allTransactionCharges",
      "allRejectionReasons",
      "allUsers",
      "allConfirmationSettings"
    ]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    showDeleteBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 404).map(r => r.AllowDelete)) == 1){
        return true
      }
    }
    return false;
    },

    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 404).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 404).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 404).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 404).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  methods: {
    ...mapActions([
      "createNMIRebate",
      "updateNMIRebate",
      "deleteNMIRebate"
   ]),

    async createNew() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        this.rebate.MakerID = this.currentUser.SecurityUserID,
        this.rebate.CheckerID = this.CheckerID,
        this.rebate.LastUserID = this.currentUser.SecurityUserID,
        this.createNMIRebate(this.rebate)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newNMIRebate',
            data: response.data
          });
          this.message = response.data.message
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })        
      }
    },

    async update() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
          if(this.currentRebate.CheckerID==0)
          {
                 //this.currentRebate.MakerID = this.currentUser.SecurityUserID
        this.currentRebate.LastUserID = this.currentUser.SecurityUserID,
        this.currentRebate.RejectionID = this.RejectionStatus,
        this.currentRebate.CheckerID = 0,
        this.currentRebate.CheckDate = null,
     //   this.currentRebate.MakeDate = new Date(),

        this.updateNMIRebate(this.currentRebate)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updNMIRebate',
            data: this.currentRebate
          });
          
          this.message = response.data.message
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })       
          }
          else{
                 this.currentRebate.MakerID = this.currentUser.SecurityUserID
        this.currentRebate.LastUserID = this.currentUser.SecurityUserID,
        this.currentRebate.RejectionID= this.RejectionStatus,
       this.currentRebate.CheckerID = 0,
        this.currentRebate.CheckDate = null,
        this.currentRebate.MakeDate = new Date(),

        this.updateNMIRebate(this.currentRebate)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updNMIRebate',
            data: this.currentRebate
          });
          
          this.message = response.data.message
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })       
          }
      }
    },
    // delete function

    deleteItem() {
      this.message = '';
      this.deleteNMIRebate(this.currentRebate)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'dltNMIRebate',
          data: this.currentRebate
        });
        
        this.message = response.data.message
        this.deleteDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.deleteDialog=false
      })        
   },

    updateStatus() {
      this.message = '';

      this.currentRebate.CheckerID = this.currentUser.SecurityUserID,
      this.currentRebate.LastUserID = this.currentUser.SecurityUserID,
      this.currentRebate.RejectionID = this.RejectionStatus,
      this.currentRebate.CheckDate = new Date(),
      this.currentRebate.updatedAt = new Date(),

      this.updateNMIRebate(this.currentRebate)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updNMIRebate',
          data: this.currentRebate
        });
        
        this.message = response.data.message
        this.refreshList()
       this.rejectionDialog = false;
        this.RejectionStatus = 0
     },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.rejectionDialog = false;
        this.RejectionStatus = 0
      })
    },

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("NMI Rebate Rates", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('NMIRebateRates.pdf')
      }
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedNMIRebates = false
    },

    getCountryName(id) {
      return this.allCountries.filter(a => a.CountryId === id).map(a => a.CountryName).toLocaleString()
    },

    getCityName(id) {
      return this.allCities.filter(a => a.CityID === id).map(a => a.City).toLocaleString()
    },

    showEdit () {
      this.edit = true
    },

    closeEdit() {
      this.edit = false
    },

    showCreate () {
      this.create = true
    },

    closeCreate() {
      this.office = {};
      this.create = false
    },

    reject () {
      this.rejectionDialog = true
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
    },

    reset () {
      this.$refs.form.reset()
    },

    setActiveRebate (item, index) {
      this.currentRebate = item
      this.currentIndex = index
    },
  },

  mounted () {
    UserService.isRates().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("unconfirmedNMIRebates", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white
}
</style>
